import {
  CART,
  CART_ADD_LINES,
  CART_ATTRIBUTES_UPDATE,
  CART_BUYER_IDENTITY_UPDATE,
  CART_CREATE,
  CART_DISCOUNT_CODES_UPDATE,
  CART_NOTE_UPDATE,
  CART_REMOVE_LINES,
  CART_UPDATE_LINES
} from './cart';
import { PRODUCTS, PRODUCT_COLLECTIONS } from './products';

export const StorefrontQueries = {
  Cart: CART,
  CartCreate: CART_CREATE,
  CartAddLines: CART_ADD_LINES,
  CartRemoveLines: CART_REMOVE_LINES,
  CartUpdateLines: CART_UPDATE_LINES,
  CartUpdateNote: CART_NOTE_UPDATE,
  CartUpdateAttributes: CART_ATTRIBUTES_UPDATE,
  CartUpdateBuyerIdentity: CART_BUYER_IDENTITY_UPDATE,
  CartUpdateDiscountCodes: CART_DISCOUNT_CODES_UPDATE,
  Products: PRODUCTS,
  ProductCollections: PRODUCT_COLLECTIONS
};
